import { post } from '../util/fetchUtil';
import { getSearchParams } from './params';

export default async () => {
  const { key } = getSearchParams(window.location.href);
  const res = await post('/checkPuppeteerAccess', { key });
  return res?.access ? key : null;
};
